import styled from 'styled-components';
import {
  screenSize,
  whiteColor,
  primaryColor,
  mediumFont,
  boldFont,
  secondaryColor,
  regularFont,
} from '@app/styles';
import Logo from '@app/assets/images/munitechlogo.png';
type Props = {
  deleted?: boolean;
};

export const SelectItem = styled.div`
  width: 100%;
  margin-bottom: 20px;
  @media (${screenSize.tablet}) {
    width: 302px;
  }
  .munitech-select .munitech__control {
    height: auto;
  }
`;

export const SelectLabel = styled.label`
  color: #0f1d2a;
  text-align: left;
  line-height: 21px;
  font-size: 15px;
  opacity: 0.5;
  ${mediumFont};
`;

export const Label = styled.div`
  font-size: 14px;
  line-height: 21px;
  color: #6b6f8c;
  // padding-bottom: 5px;
  ${regularFont};
`;

export const Star = styled.label`
  font-size: 15px;
  color: red;
  text-align: left;
  line-height: 21px;
  ${mediumFont}
`;

export const BackgroundContainer = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow-x: hidden;
  @media (${screenSize.tablet}) {
    display: block;
  }
`;

export const Status = styled.div`
  display: flex;
  justify-content: end;
  margin-right: 10px;
  margin-top: -20px;
  > div {
    font-size: 13px;
  }
  @media (${screenSize.tablet}) {
    margin-right: 30px;
  }
`;
export const SwitchCard = styled.div`
  margin-right: 10px;
`;

export const FormContainer = styled.div`
  position: relative;
  width: 95%;
  overflow-x: hidden;
  overflow-y: auto;
  padding: 0px 12px 0px 12px;
  margin: 154px auto 0px;
  box-shadow: rgb(100 112 119 / 20%) 0px 5px 10px 0px;
  border-radius: 8px;
  background: ${whiteColor};
  @media (${screenSize.maxMobile}) {
    height: calc(100vh - 154px);
  }
  @media (${screenSize.tablet}) {
    width: calc(100vw - 120px);
    height: calc(100vh-154px);
    margin: auto;
    margin-top: 154px;
    margin-bottom: 50px;
    padding: 0px 0px 80px 40px;
    border-radius: 8px;
  }
`;
export const InfoBox = styled.div`
  width: 100%;
  @media (${screenSize.tablet}) {
    padding-top: 22px;
  }
`;

export const PrimaryInfoBox = styled.div`
  width: 100%;
  @media (${screenSize.tablet}) {
    margin-top: 16px;
  }
`;
export const PrimaryHeading = styled.div`
  font-size: 18px;
  color: #27323c;
  margin-bottom: 0;
  margin-top: 18px;
  font-family: Noto Serif;
  ${boldFont};
`;
export const Heading = styled.div`
  font-size: 16px;
  color: #27323c;
  margin-bottom: 0;
  ${boldFont}
`;
export const Text = styled.p`
  font-size: 15px;
  color: #27323c;
  opacity: 0.8;
  padding: 0;
  margin-top: 10px;
`;
export const InfoCard = styled.div`
  width: 100%;
  @media (${screenSize.tablet}) {
    display: flex;
    justify-content: flex-start;
    flex-direction: row;
    align-items: center;
  }
`;
export const MultiInfoCard = styled.div`
  width: 100%;
  @media (${screenSize.tablet}) {
    display: flex;
    justify-content: flex-start;
    flex-direction: row;
    align-items: center;
    ${({ deleted }: Props) => {
      if (deleted) {
        return `display:none`;
      }
    }}
  }
`;

export const PrimaryInfoCard = styled.div`
  width: 100%;
  @media (${screenSize.tablet}) {
    display: flex;
    margin-top: 5px;
    justify-content: flex-start;
    flex-direction: row;
    align-items: center;
  }
`;
export const InfoItem = styled.div`
  width: 100%;
  position: relative;
  @media (${screenSize.tablet}) {
    padding-right: 20px;
    width: 322px;
    margin: 0;
  }
`;
export const PrimaryInfoItem = styled.div`
  width: 100%;
  position: relative;
  @media (${screenSize.tablet}) {
    padding-right: 20px;
    width: 642px;
    margin: 0;
    margin-top: -8px;
  }
`;
export const SecondaryInfoItem = styled.div`
  width: 100%;
  position: relative;
  margin-top: -8px;
  @media (${screenSize.tablet}) {
    padding-right: 20px;
    width: 645px;
    margin: 0;
  }
`;
export const RadioItem = styled.div`
  width: 100%;
  position: relative;
  @media (${screenSize.tablet}) {
    width: 100px;
    padding-right: 28px;
    margin: 0;
  }
`;
export const SecondaryInfoCard = styled.div`
  width: 100%;
  @media (${screenSize.tablet}) {
    display: flex;
    justify-content: flex-start;
    flex-direction: column;
    align-items: center;
  }
`;
export const NumText = styled.div`
  width: 20px;
  padding-right: 10px;
  padding-bottom: 20px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
`;
export const TaxText = styled.div`
  padding-right: 10px;
  padding-bottom: 20px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
`;

export const AddNewText = styled.div`
  color: ${primaryColor};
  text-align: center;
  font-size: 14px;
  cursor: pointer;
  ${mediumFont};
  margin-left: 22px;
  margin-bottom: 20px;
`;
export const RemoveText = styled.div`
  color: ${secondaryColor};
  text-align: center;
  font-size: 14px;
  cursor: pointer;
  ${mediumFont};
  padding-bottom: 20px;
`;

export const TaxRate = styled.div`
  margin-top: -8px;
  @media (${screenSize.tablet}) {
    width: 84px;
    margin-right: 12px;
  }
`;
export const Dollar = styled.div`
  opacity: 0.8;
  font-size: 18px;
  color: #27323c;
  margin-right: 12px;
  padding-bottom: 22px;
`;

export const TaxInstcard = styled.div`
  margin-top: -10px;
`;
export const Instcard = styled.div``;
export const InspectionInst = styled.div``;

export const ErrorMessage = styled.p`
  font-size: 14px;
  color: red;
  margin: 0;
  position: absolute;
  bottom: -22px;
  @media (${screenSize.tablet}) {
    bottom: 0;
  }
`;
export const PriceErrorMessage = styled.p`
  font-size: 14px;
  color: red;
  margin: 0;
  padding-bottom: 10px;
  margin-top: -15px;
  @media (${screenSize.tablet}) {
    bottom: 0;
  }
`;
export const MunitechLogo = styled.div`
  width: 30px;
  height: 30px;
  position: absolute;
  margin-left: 10px;
  border-radius: 8px;
  margin-right: 10px;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  cursor: pointer;
  background-image: url(${Logo});
`;

export const Loader = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  top: 30px;
  position: absolute;
`;
